// Gemini-compatible version of SheetSpec schema

import { SheetSpecSchema } from './sheetspec.schema.js';

/**
 * Convert JSON Schema to Gemini-compatible format
 * - Converts 'const' to 'enum' with single value (Gemini uses enum instead of const)
 */
function convertToGeminiSchema(schema: any): any {
  if (typeof schema !== 'object' || schema === null) {
    return schema;
  }

  if (Array.isArray(schema)) {
    return schema.map(convertToGeminiSchema);
  }

  const converted: any = {};

  for (const [key, value] of Object.entries(schema)) {
    // Convert 'const' to 'enum' with single value
    if (key === 'const') {
      converted.enum = [value];
      continue;
    }

    // Recursively convert nested objects
    converted[key] = convertToGeminiSchema(value);
  }

  return converted;
}

/**
 * SheetSpec schema converted to Gemini-compatible format
 * Use this when calling Gemini API with structured outputs
 */
export const GeminiSheetSpecSchema = convertToGeminiSchema(SheetSpecSchema);
